import React, { useState } from 'react';

import _ from 'lodash';
import DefaultLayout from '@/Components/DefaultLayout';
import { InboxTable } from '@/Components/LayoutPart/DataTable';
import { CommonColors } from '@/Themes';
import {
  Button,
  Divider,
  Grid,
  InputLabel,
  TextField,
  Typography,
} from '@mui/material';
import { InboxDetail } from '@/Components/Dialogs';
import { useTranslation } from 'react-i18next';
import { InboxActions } from '@/Actions';
import { IDataInbox, IFilterInbox } from '@/Interfaces/Inbox.interface';
import { useTypedDispatch } from '@/store';

const DEFAULT_FILTER = {
  page: 1,
  limit: 10,
  email: '',
};

const { fetchInbox } = InboxActions;

const InboxManagement = () => {
  const { t } = useTranslation('translation');
  const dispatch = useTypedDispatch();
  const [filter, setFilter] = useState<IFilterInbox>(DEFAULT_FILTER);
  const [inboxDetail, setInboxDetail] = useState<IDataInbox>();

  const [openDetailInbox, setOpenDetailInbox] = React.useState<boolean>(false);

  const onRowAction = (data: IDataInbox, action: 'detail') => {
    if (action === 'detail') {
      setOpenDetailInbox(true);
      setInboxDetail(data);
    }
  };

  const _renderTopInbox = () => {
    return (
      <Grid container>
        <Grid item xs={8}>
          <Typography
            sx={{ color: CommonColors.mainColor, letterSpacing: 5 }}
            variant="h4"
          >
            {t('title.unsubscribeInbox')}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const _renderBody = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={4} display={'flex'}>
          <InputLabel sx={{ minWidth: '14vh', mt: 1 }}>
            {t('label.searchBy')}
          </InputLabel>
          <TextField
            value={filter?.email}
            size="small"
            label="Email"
            fullWidth
            onChange={(e) => setFilter({ ...filter, email: e.target.value })}
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            sx={{
              mr: 1,
              background: CommonColors.bismark,
              '&:hover': {
                background: '#486270',
              },
            }}
            onClick={() => dispatch(fetchInbox({ ...filter, page: 1 }))}
          >
            {t('button.filter')}
          </Button>
          <Button
            variant="outlined"
            sx={{
              border: '1px solid #28384580',
              color: CommonColors.gratou,
              '&:hover': {
                border: '1px solid #1e2a3480',
              },
            }}
            onClick={() => {
              setFilter(DEFAULT_FILTER);
              dispatch(fetchInbox(DEFAULT_FILTER));
            }}
          >
            {t('button.reset')}
          </Button>
        </Grid>
        <Grid item xs={12}>
          <InboxTable onRowAction={onRowAction} />
        </Grid>
      </Grid>
    );
  };

  const renderMain = () => {
    return (
      <Grid container spacing={2} p={2}>
        <Grid item xs={12}>
          {_renderTopInbox()}
          <Divider />
        </Grid>
        <Grid item xs={12}>
          {_renderBody()}
        </Grid>
        {openDetailInbox && (
          <InboxDetail
            open={openDetailInbox}
            onClose={async () => {
              setOpenDetailInbox(false);
              setInboxDetail({});
              await dispatch(
                fetchInbox({
                  filter,
                })
              );
            }}
            data={inboxDetail}
          />
        )}
      </Grid>
    );
  };
  return <DefaultLayout portalFor="ADMIN" content={renderMain()} />;
};

export default InboxManagement;
